import React from "react";
import Slider from "react-slick";
import "slick-carousel/slick/slick.css";
import "slick-carousel/slick/slick-theme.css";

const generateRandomData = (index) => {
  const randomValue = Math.random();

  let randomLastName = "";
  if (randomValue < 0.4) {
    randomLastName = "김";
  } else if (randomValue < 0.7) {
    randomLastName = "이";
  } else if (randomValue < 0.9) {
    randomLastName = "박";
  } else {
    const otherLastNames = ["최", "정", "오", "한", "나", "윤", "배"];
    randomLastName = otherLastNames[Math.floor(Math.random() * otherLastNames.length)];
  }

  const randomPhone = `010-****-${Math.floor(1000 + Math.random() * 9000)}`;

  const today = new Date();
  const randomDays = Math.floor(Math.random() * 2);
  today.setDate(today.getDate() - randomDays);
  const formattedDate = today.toISOString().split("T")[0];

  return {
    id: index + 1,
    status: "신청완료",
    name: `${randomLastName}**`,
    phone: randomPhone,
    date: formattedDate,
  };
};

const DBAnimation = () => {
  const data = Array.from({ length: 50 }, (_, i) => generateRandomData(i));

  const settings = {
    dots: false,
    infinite: true,
    speed: 1000,
    slidesToShow: 5,
    slidesToScroll: 1,
    vertical: true,
    autoplay: true,
    autoplaySpeed: 2000,
    pauseOnHover: false,
    arrows: false,
  };

  return (
    <div className="db-wrapper">
      <h2 className="db-title">실시간 신청현황</h2>
      <div className="db-list-container">
        <Slider {...settings}>
          {data.map((item) => (
            <div key={item.id} className="db-item-wrapper">
              <div className="db-status-section">
                <span className="db-status-badge">{item.status}</span>
                <span className="db-user-name">{item.name}</span>
                <span className="db-user-phone">{item.phone}</span>
                <span className="db-user-date">{item.date}</span>
              </div>
            </div>
          ))}
        </Slider>
      </div>

      <style jsx>{`
        .db-wrapper {
            width: 100%;
          background: #f0f0f0;
          padding: 25px;
          display: flex;
          flex-direction: column;
          align-items: center;
        }

        .db-title {
          font-size: 40px;
          font-weight: bold;
          color: #333;
          margin-bottom: 15px;
        }

        .db-list-container {
          width: 100%;
          max-width: 500px;
          box-shadow: 0px 4px 12px rgba(0, 0, 0, 0.1);
          overflow: hidden;
        }

        .db-item-wrapper {
          display: flex;
          align-items: center;
          justify-content: space-between;
          padding: 17px;
          box-shadow: 2px 2px 6px rgba(0, 0, 0, 0.05);
          background-color: white;
        }

        .db-status-section {
          display: flex;
          align-items: center;
          gap: 10px;
          flex: 2;
          background-color: white;
        }

        .db-status-badge {
          background: #d32f2f;
          color: white;
          padding: 6px 12px;
          border-radius: 5px;
          font-weight: bold;
          font-size: 13px;
        }

        .db-user-name {
          font-size: 14px;
          font-weight: bold;
          color: #333;
        }

        .db-user-phone {
          font-size: 14px;
          color: #555;
          text-align: center;
          flex: 2;
        }

        .db-user-date {
          font-size: 13px;
          font-style: italic;
          color: #888;
          text-align: right;
          flex: 1;
        }
      `}</style>
    </div>
  );
};

export default DBAnimation;
